<div traverseTo="/" class="auth_header">
  <img class="logo" *ngIf="logo" src="{{logo}}"/>
</div>
<ng-content #form></ng-content>
